var testswiper = new Swiper('.nb-testimonials-slider', {
    centeredSlides: true,
    loop: true,
    scrollbar: {
      el: '.swiper-scrollbar',
      hide: true,
    },
  
    navigation: {
      nextEl: '.swiper-button-nexttest',
      prevEl: '.swiper-button-prevtest',
    },
  
    breakpoints: {
      1350: {
        slidesPerView: 1,
        spaceBetween: 60,
      },
      750: {
        slidesPerView: 1,
        spaceBetween: 40,
      },
      0: {
        slidesPerView: 1.3,
        spaceBetween: 6,
      },
    },
  
    on: {
      init: function () {
        updateNbTestimonialArrows(this);
      },
  
      resize: function () {
        updateNbTestimonialArrows(this);
      },
  
      slideChangeTransitionEnd: function () {
        updateNbTestimonialArrows(this);
      }
    }
  });
  
  
  function updateNbTestimonialArrows(swiper) {
  
    if (window.innerWidth < 750) {
      return;
    }
  
    const activeSlide = swiper.slides[swiper.activeIndex];
  
    if (!activeSlide) {
      return;
    }
  
    const prevButton =
      swiper.el.querySelector('.swiper-button-prevtest');
  
    const nextButton =
      swiper.el.querySelector('.swiper-button-nexttest');
  
    if (!prevButton || !nextButton) {
      return;
    }
  
    const sliderRect =
      swiper.el.getBoundingClientRect();
  
    const slideRect =
      activeSlide.getBoundingClientRect();
  
    prevButton.style.left =
      `${slideRect.left - sliderRect.left - 27}px`;
  
    nextButton.style.left =
      `${slideRect.right - sliderRect.left - 27}px`;
  
    prevButton.style.right = 'auto';
    nextButton.style.right = 'auto';
  }
  
  
  /* Testimonials section animation */
  
  const nbTestimonialsSection2 = document.querySelector('.nb-testimonials-section');
  
  if (nbTestimonialsSection2) {
    const observer2 = new IntersectionObserver(
      (entries, observer) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            nbTestimonialsSection2.classList.add('is-visible');
            observer.unobserve(nbTestimonialsSection2);
          }
        });
      },
      {
        threshold: 0.2
      }
    );
    observer2.observe(nbTestimonialsSection2);
  }